module.exports = __webpack_public_path__ + "static/img/Certification1.abb7c85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Certification1.png
// module id = Dszc
// module chunks = 1